import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IWebinarState, IWebinar } from 'interfaces/webinars'
import { RootState } from '..'

const initialState: IWebinarState = {
  items: [],
  loading: false,
  loaded: false,
}

const webinarsSlice = createSlice({
  name: 'webinars',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setItems: (state, action: PayloadAction<IWebinar[]>) => {
      state.items = action.payload
      state.loaded = true
    },
  },
})

const { setLoading, setItems } = webinarsSlice.actions
const loading = (state: RootState) => state.webinars.loading
const loaded = (state: RootState) => state.webinars.loaded
const items = (state: RootState) => state.webinars.items

export const webinars = { setLoading, setItems, loading, loaded, items }

export default webinarsSlice.reducer
